import { createSlice } from "@reduxjs/toolkit";

interface CountLineState {
	addLineFormOpen: boolean;
	startSessionDialogOpen: boolean;
}

const initialState: CountLineState = {
	addLineFormOpen: false,
	startSessionDialogOpen: false
};

export const countLineSlice = createSlice({
	initialState,
	name: "countLine",
	reducers: {
		closeAddLineForm: (state) => {
			state.addLineFormOpen = false;
		},
		closeStartSessionDialog: (state) => {
			state.startSessionDialogOpen = false;
		},
		openAddLineForm: (state) => {
			state.addLineFormOpen = true;
		},
		openStartSessionDialog: (state) => {
			state.startSessionDialogOpen = true;
		}
	}
});

export const { closeAddLineForm, closeStartSessionDialog, openAddLineForm, openStartSessionDialog } =
	countLineSlice.actions;

export default countLineSlice.reducer;
